/**
 * @generated SignedSource<<ab41a41fb2a41cf920feb6cf5084349d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignStakeholderCategoryInputObject = {
  categoryId: string;
  stakeholderId: string;
};
export type reviewPage_AssignStakeholderCategoryMutation$variables = {
  input: AssignStakeholderCategoryInputObject;
};
export type reviewPage_AssignStakeholderCategoryMutation$data = {
  readonly assignStakeholderCategory: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly category: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type reviewPage_AssignStakeholderCategoryMutation = {
  response: reviewPage_AssignStakeholderCategoryMutation$data;
  variables: reviewPage_AssignStakeholderCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Category",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "reviewPage_AssignStakeholderCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignStakeholderCategoryMutationPayload",
        "kind": "LinkedField",
        "name": "assignStakeholderCategory",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "reviewPage_AssignStakeholderCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignStakeholderCategoryMutationPayload",
        "kind": "LinkedField",
        "name": "assignStakeholderCategory",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1d9b9e48a32048f82cf9b744c5c448e3",
    "id": null,
    "metadata": {},
    "name": "reviewPage_AssignStakeholderCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation reviewPage_AssignStakeholderCategoryMutation(\n  $input: AssignStakeholderCategoryInputObject!\n) {\n  assignStakeholderCategory(input: $input) {\n    stakeholder {\n      id\n      category {\n        id\n        name\n      }\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44a5e4a27bf123cf4850b7f78bfce829";

export default node;
